import React from 'react';
import { BADGE_STYLE, typeShort } from '@/lib/payments';

/** Distintivos de viático / canasta al día, pendiente o atrasado (solo admin los recibe del backend). */
const PaymentBadges = ({ badges }) => {
  const entries = Object.entries(badges || {});
  if (entries.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1 mt-1" data-testid="payment-badges">
      {entries.map(([type, state]) => {
        const st = BADGE_STYLE[state] || BADGE_STYLE.al_dia;
        return (
          <span
            key={type}
            title={`${typeShort(type)} mensual: ${st.label.toLowerCase()}`}
            className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-medium ${st.cls}`}
          >
            {typeShort(type)} · {st.label}
          </span>
        );
      })}
    </div>
  );
};

export default PaymentBadges;
